/* eslint-disable max-len, camelcase */
import $http from '@/modules/FPKG-20000-Util/prototypes/axios'; // 後端溝通
import errorCode from '../../errorCode'; // 進行後端error code提示


import {
  INFO, MODIFY, DO_MODIFY,
} from './declare';

export {
  INFO, MODIFY, DO_MODIFY,
};

/**
 * 發出請求，向後端送資料 並回傳非同步資料
 */
const Getter = {
  async info(params: INFO.request): Promise<INFO.AxiosResponse> {
    return $http.get(INFO.API, { params }).then((d) => {
      if (d.data.code !== 0) { throw errorCode(d.data); }
      return d;
    });
  },


  async modify(params: MODIFY.request): Promise<MODIFY.AxiosResponse> {
    return $http.get(MODIFY.API, { params }).then((d) => {
      if (d.data.code !== 0) { throw errorCode(d.data); }
      return d;
    });
  },

  async doModify(params: DO_MODIFY.request): Promise<DO_MODIFY.AxiosResponse> {
    return $http.put(DO_MODIFY.API, params).then((d) => {
      if (d.data.code !== 0) { throw errorCode(d.data); }
      return d;
    });
  },
};

export default Getter;
